// Note re naming of files - need to use lower case, ie zh-cn, as jenkins builds fail with upper case, ie zh-CN
import messages from "./pt-pt.json";
export const dateFormat = {
  pt: {
    "event-overview": "MMM Do",
    "report-date": "DD/MM/YYYY HH:mm",
    "date-DD/MM/YYYY": "DD/MM/YYYY",
    "time-HH:mm": "HH:mm",
    "date-DD/MM": "M/DD",
  },
};
export const message = {
  "pt-PT": messages,
};
